<template>
  <div>
    <!-- Vídeo principal -->
    <div
      :class="$vuetify.breakpoint.smAndDown ? 'videoBlurMobile' : 'videoBlur'"
      style="height: 30vh;"
    >
      <v-skeleton-loader
        v-if="!videoLoaded"
        type="image"
        style="height: 30vh;"
      ></v-skeleton-loader>
      <video
        v-show="videoLoaded"      
        width="100%"
        height="100%"
        autoplay
        muted
        loop
        webkit-playsinline
        playsinline
        style="object-fit: cover;"
        @canplaythrough="() => gamesCategoryList && (videoLoaded = true)"
      >
        <source src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/PRAGMATIC+PLAY+TURNS+UP+THE+HEAT+IN+STRIKING+HOT+5%E2%84%A2.mp4" type="video/mp4">
        <source src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/PRAGMATIC+PLAY+SEEKS+HEAVENLY+FAVOUR+IN+QUEEN+OF+GODS%E2%84%A2.mp4" type="video/mp4">
        <source src="https://dozr8la71aog.cloudfront.net/videos/pragmaticplay/6300x+Bet+Win+-+Buffalo+King+-+Pragmatic+Play.mp4" type="video/mp4">
      </video>
    </div>

    <!-- Menu de categorias -->
    <MenuCategories
      :style="{
        position: 'sticky',
        top: $vuetify.breakpoint.mdAndDown ? '-2px' : '62px',
        'z-index': 2,
      }"
      :categoryActive="gamesCategoryName"
      @spacemanGame="gameClicked(spaceman, false)"
    />

    <v-container
      class="px-4"
      :class="$vuetify.breakpoint.mdAndDown ? 'mt-4' : 'mt-8'"
    >
      <!-- Início radialGradient pelo site -->
      <div
        v-if="!$vuetify.breakpoint.smAndDown"
        class="radialGradientRight"
      ></div>
      <div
        class="radialGradientLeft"
        :style="{
          top: $vuetify.breakpoint.smAndDown && '900px'
        }"
      ></div>
      <!-- Fim radialGradient pelo site -->

      <div class="d-flex align-center ml-n2 mb-4">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div
          class="ml-2"
          :class="$vuetify.breakpoint.smAndDown ? 'text-h6' : 'text-h4'"
          style="filter: blur(0);"
        >
          {{ gamesCategoryName }}
        </div>
      </div>

      <div class="row"> 
        <div
          v-for="(game, index) in gamesCategoryList"
          :key="game.id_game_simple"
          class="d-flex col-sm-6 col-md-4 col-lg-3 col-xl-2 col-6"
          :class="$vuetify.breakpoint.smAndDown && 'pa-1'"
        >
          <v-hover v-slot="{ hover }">
            <div
              class="v-image v-responsive theme--dark"
              :class="index + 1 === gamesCategoryList.length ? 'mr-2' : ''"
              :style="{
                'max-width': '100%',
                'border-radius': '8px',
                'border': '1px solid rgba(255, 255, 255, 0.3)',
              }"
            >
              <div class="v-responsive__sizer" style="padding-bottom: 72%;"></div>
              <img
                class="v-image__image v-image__image--cover" 
                :src="game.hasDGAData
                  ? getTableDataGame(game.id_game_simple, 'tableImage')
                  : `${gameAPI}/game_pic/rec/325/${game.id_game_simple}.png`
                "
                style="background-position: center center;"
                @load="game.imageLoaded = true"
              >
              <div class="v-responsive__content" style="width: 325px;"></div>
              <v-skeleton-loader
                v-if="!game.imageLoaded"
                type="image"
                :style="{
                  height: $vuetify.breakpoint.smAndDown ? '120px' : '180px',
                }"
              >
              </v-skeleton-loader>
              <!-- Se nao for cassino ao vivo, ativar efeito de hover -->
              <v-overlay
                v-if="hover && game.imageLoaded && !isLiveCasino"
                opacity="0.7"
                absolute
              >
                <div class="d-flex flex-column align-center">
                  <v-btn
                    color="primary"
                    :small="$vuetify.breakpoint.smAndDown"
                    style="border-radius: 8px;"
                    @click="gameClicked(game, false)"
                  >
                    {{ $t("play") }}
                  </v-btn>
                  <v-btn
                    v-if="game.id_tipo !== 'lg'"
                    color="primary"
                    outlined
                    :small="$vuetify.breakpoint.smAndDown"
                    :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : 'mt-5'"
                    style="
                      background-color: black;
                      border-radius: 8px;
                      border-width: 2px;
                      opacity: 0.8;
                    "
                    @click="gameClicked(game, true)"
                  >
                    DEMO
                  </v-btn>
                </div>
              </v-overlay>
              <!-- Se for cassino ao vivo mostrar dados do jogo -->
              <div
                v-if="isLiveCasino"
                class="d-flex flex-column justify-space-between"
                style="width: 100%; height: 100%;"
              >
                <div class="d-flex justify-space-between pa-2">
                  <div class="d-flex flex-column justify-start align-start">
                    <!-- Aposta minima e maxima da mesa -->
                    <div
                      v-if="getTableDataGame(game.id_game_simple, 'minBet')"
                      :class="$vuetify.breakpoint.xsOnly
                        ? 'px-1 py-1 mb-1 caption'
                        : 'px-2 py-2 mb-2 body-2'
                      "
                      style="
                        background-color: rgba(0, 0, 0, 0.5);
                        border-radius: 8px;
                      "
                    >
                    <!-- Multiplicar por 5 para converter o valor que vem do DGA em EURO -->
                      R$ {{ getTableDataGame(game.id_game_simple, 'minBet') * 5 }}
                    - 
                      R$ {{ getTableDataGame(game.id_game_simple, 'maxBet') * 5 }}
                    </div>
                    <!-- Total de jogadores e maximo de jogadores da mesa -->
                    <div
                      v-if="getTableDataGame(game.id_game_simple, 'tableOpen')"
                      class="d-flex align-center justify-center"
                      :class="$vuetify.breakpoint.xsOnly
                        ? 'px-1 py-1 caption'
                        : 'px-2 py-2 body-2'
                      "
                      style="
                        background-color: rgba(0, 0, 0, 0.5);
                        border-radius: 8px;
                      "
                    >
                      <v-icon size=20 color="green">mdi-account</v-icon>
                      {{
                        getTableDataGame(game.id_game_simple, "totalSeatedPlayers")
                        + " / " +
                        getTableDataGame(game.id_game_simple, "maxPlayers")
                      }}
                    </div>
                    <!-- Caso a mesa esteja fechada -->
                    <div
                      v-else
                      class="d-flex align-center justify-center"
                      :class="$vuetify.breakpoint.xsOnly
                        ? 'px-1 py-1 caption'
                        : 'px-2 py-2 body-2'
                      "
                      style="
                        background-color: rgba(0, 0, 0, 0.5);
                        border-radius: 8px;
                      "
                    >
                      <v-icon size=20 color="red">mdi-account-cancel</v-icon>
                      {{ $t("closed") }}
                    </div>
                  </div>
                  <!-- Nome do dealer -->
                  <div
                    v-if="getTableDataGame(game.id_game_simple, 'dealer') && !$vuetify.breakpoint.xsOnly"
                    :class="$vuetify.breakpoint.xsOnly
                      ? 'px-1 py-1 caption'
                      : 'px-2 py-2 body-2'
                    "
                    style="
                      background-color: rgba(0, 0, 0, 0.5);
                      border-radius: 8px;
                      height: min-content;
                    "
                  >
                    {{ getTableDataGame(game.id_game_simple, "dealer") }}
                  </div>
                </div>
                <div
                  v-if="getTableDataGame(game.id_game_simple, 'tableName')"
                  class="d-flex justify-space-between titleGradient"
                >
                  <!-- Nome do jogo -->
                  <div
                    class="pa-2 align-self-center"
                    :class="$vuetify.breakpoint.xsOnly ? 'caption' : ''"
                    :style="{
                      'z-index': 1,
                      'font-size': $vuetify.breakpoint.xsOnly ? '' : '18px',
                    }"
                  >
                    {{ getTableDataGame(game.id_game_simple, "tableName")  }}
                  </div>
                  <!-- Botao jogar -->
                  <v-btn
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="align-self-end"
                    icon
                    color="primary"
                    style="z-index: 1;"
                    @click="gameClicked(game, false)"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    class="ma-2 align-self-end"
                    color="primary"
                    style="border-radius: 8px; z-index: 1;"
                    @click="gameClicked(game, false)"
                  >
                    {{ $t("play") }}
                  </v-btn>
                </div>
              </div>
            </div>
          </v-hover>
        </div>
      </div>

      <v-dialog max-width="600" v-model="notLoggedDialog">
        <v-card flat class="mx-auto colorDominant" max-width="600">
          <v-toolbar flat tile class="colorDominant">
            <v-btn icon @click="closeNotLoggedDialog(true)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="font-weight-black title ml-6 py-4"></span>
          </v-toolbar>
          <v-card-text
            class="text-center headline font-weight-light px-10 mt-4 pb-10"
          >
            <div>
              <v-icon class="dice" style="font-size: 80px">
                mdi-dice-{{ Math.ceil(Math.random() * 5) + 1 }}
              </v-icon>
            </div>
            <div class="mt-3">
              <h6 class="white--text">
                {{ $t("toPlayInTheCasinoRegistorOrLogin") }}
              </h6>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="py-4">
            <v-spacer></v-spacer>
            <div id="dialogRegisterBtn" @click.capture="closeNotLoggedDialog()">
              <DialogRegister
                :urlRedirect="
                  `/casino/game/${currentGame.id_game_simple}/${isFreeGame}`
                "
              />
            </div>
            <div id="loginBtn" @click.capture="closeNotLoggedDialog()">
              <Login
                :urlRedirect="
                  `/casino/game/${currentGame.id_game_simple}/${isFreeGame}`
                "
              />
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Login from "@/components/login/dialog.vue";
import DialogRegister from "@/views/home/register/dialog-register";
import MenuCategories from './MenuCategories.vue';
import casino from "@/plugins/plugin-casino";
import dga from "./dga.js"

export default {
  name: "ListGamesCategories",
  // Adicionando todo codigo do ./dga.js nesse arquivo
  mixins: [dga],
  data: () => ({
    gameAPI: "https://api.prerelease-env.biz",
    spaceman: { id_game_simple: "1301", nome_jogo: "Spaceman", id_tipo: "lg" },
    isFreeGame: false,
    notLoggedDialog: false,
    currentGame: {},
    gamesCategoryName: "",
    gamesCategoryList: [],
    videoLoaded: false,
  }),
  components: {
    Login,
    DialogRegister,
    MenuCategories,
  },
  methods: {
    // Inicializa jogo clicado
    async gameClicked(game, isFreeGame) {
      if (this.$store.state.logged.status) {
        this.$router.push({
          path: `/casino/game/${game.id_game_simple}/${isFreeGame}`,
        });
        return 0;
      }
      this.currentGame = game;
      this.isFreeGame = isFreeGame;
      this.notLoggedDialog = true;

      // Desconectando DGA ao abrir modal de login
      if (this.isLiveCasino) {
        this.notLoggedDialog && this.disconnect();
      }
    },
    closeNotLoggedDialog(connectDGALiveCasino) {
      this.notLoggedDialog = false;

      // Conectar DGA se fechar o modal de login na categoria de cassino ao vivo 
      if (this.isLiveCasino && connectDGALiveCasino) {
        this.connectDGA();
      }
    },
    getGamesCategory() {
      const games = this.$store.getters.getDataCasinoGamesCategories;

      if (!games) this.$router.push({ path: "/casino/home" });

      // Filtra os dados da categoria escolhida, caso mude de idioma
      // ou não tenha dados será redirecionado para home
      try {
        const { category_name, items } = games.find((item) => item.category_name === this.categoryActive);
        this.gamesCategoryName = category_name;
        this.gamesCategoryList = items;
      } catch (error) {
        this.$router.push({ path: "/casino/home" });
      }
    },
    addDGAGamesList() { 
      // Adicionar o "hasDGAData" no objeto do jogo para requisitar a imagem da mesa
      setTimeout(() => {
        this.gamesCategoryList = this.gamesCategoryList
          .map((game) => {
            return {
              ...game,
              hasDGAData: !!this.tableData[game.id_game_simple],
            }
          });
      }, 10000);
    },
    getTableDataGame(idGameSimple, type) {
      // Verifica se existe o jogo na tableData que esta sendo criado no DGA.js - onMessage()
      // se existir, retorna o membro do objeto de acordo com a variavel "type" passada 
      if (this.tableData[idGameSimple]) {
        if (this.tableData[idGameSimple].tableType == "BLACKJACK") {
          if (type == "totalSeatedPlayers" && this.tableData[idGameSimple].totalSeatedPlayers > 7 || type == "maxPlayers") {
            return 7;
          }
        }
        return this.tableData[idGameSimple][type];
      }
    },
    connectDGA() {
      this.connect("dga.pragmaticplaylive.net", this.casinoId);
    },
  },
  watch: {
    $route() {
      this.categoryActive = this.$route.params.category;
      this.gamesCategoryName = "";
      this.gamesCategoryList = [];

      if (this.categoryActive === "Spaceman") return;

      if (!this.isLiveCasino) {
        // Desconectando DGA
        this.disconnect();
      } else if (this.isLiveCasino) {
        // Iniciando conexao com a dga ao entrar na categoria de cassino ao vivo
        // por outra categoria
        this.connectDGA();
        // Adicionando hasDGA nos jogos do cassino ao vivo que tem DGA
        this.addDGAGamesList();
      }
      
      this.getGamesCategory();
    }
  },
  async mounted() {
    this.categoryActive = this.$route.params.category;
    this.gamesCategoryName = "";
    this.gamesCategoryList = [];

    if (this.categoryActive !== "Spaceman") this.getGamesCategory();

    // Guarda jogo aberto quando tentativa de jogar sem logar foi realizada
    // para que o site redirecione automaticamente pra ele quando o user logar
    if (this.$route.params.openLoginDialog) {
      this.notLoggedDialog = true;

      // Caso o jogo a ser redirecionado seja o "Spaceman", atribui os dados do
      // spaceman ao currentGame 
      if (this.$route.params.redirectedGameName === '1301') {
        this.currentGame = this.spaceman;
        return;
      }

      this.currentGame = this.gamesCategoryList.find(
        (el) => el.id_game_simple === this.$route.params.redirectedGameName
      );
    }

    // Setando dgaId
    const dgaId = await casino.fetchDgaId();
    // Setando dgaId no mixin dga
    this.setCasinoId(dgaId);

    // Iniciando conexao com a dga ao entrar na categoria de cassino ao vivo
    // por outra categoria
    if (this.isLiveCasino) {
      // Iniciando conexao com a dga
      this.connectDGA();
      // Adicionando hasDGA nos jogos do cassino ao vivo que tem DGA
      this.addDGAGamesList();
    }
  },
  beforeDestroy() {
    if (this.websocket != null) {
      // Desconectando DGA
      this.disconnect();
    }
  },
  computed: {
    isIOS() {
      return ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
    },
    isLiveCasino() {
      const category = this.$route.params.category;
      return category === this.$t("liveCasino");
    },
  },
}
</script>

<style scoped>
@keyframes rotation {
  0% {
    transform: rotate(0deg);
    top: -70px;
    left: -200px;
  }
  25% {
    top: -50px;
  }
  50% {
    top: -30px;
  }
  75% {
    top: -10px;
    left: -50px;
  }
  100% {
    transform: rotate(180deg) scale(1);
    left: 0px;
  }
}
.dice {
  animation-name: rotation;
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
}
.v-skeleton-loader.v-skeleton-loader--is-loading >>> .v-skeleton-loader__image {
  height: 100%;
}
.radialGradientRight, .radialGradientLeft {
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, var(--v-primary-base) 0%, 
    var(--v-colorDominant-base) 100%);
  filter: blur(150px);
}
.radialGradientRight {
  right: -100px;
  top: 400px;
}
.radialGradientLeft {
  left: -100px;
  top: 800px;
}
.videoBlur, .videoBlurMobile {
  position: relative;
}
.videoBlur::after, .videoBlurMobile::after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(69, 69, 69, 0) 80%, rgb(0, 0, 0) 92%, rgba(69, 69, 69, 0) 98%);
}
.videoBlur::after {
  bottom: -30px;
}
.videoBlurMobile::after {
  bottom: -20px;
}
.titleGradient {
  position: relative;
}
.titleGradient::after {
  content: "";
  position: absolute;
  display: block;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
}
</style>